<ng-container
    *ngTemplateOutlet="footerDrawerService.template$ | async"
></ng-container>
